import { Search } from 'lucide-react';
import { observer } from 'mobx-react';
import * as React from 'react';
import { translation, TranslationsContext } from '../../../Translations';
import ParticipantsV2Store from './Store';

interface Props {
  store: ParticipantsV2Store;
}

const typed = (store: ParticipantsV2Store) => (event: React.ChangeEvent<HTMLInputElement>) =>
  store.typed(event.target.value);

function QueryBar({ store }: Props) {
  // Read here, not inside the Consumer callback: observer only tracks reads
  // made during this component's own render, so a read in the callback would
  // never re-render the input as the admin types.
  const { searchText } = store;

  return (
    <TranslationsContext.Consumer>
      {(ts) => (
        <div className="relative mb-4 w-full max-w-md">
          <Search
            className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground"
            aria-hidden="true"
          />
          <input
            type="search"
            value={searchText}
            onChange={typed(store)}
            placeholder={translation('Search Name or Email')(ts)}
            aria-label={translation('Search Name or Email')(ts)}
            className="w-full rounded-md border border-border bg-card py-2 pl-9 pr-3 text-foreground focus:outline-none focus:ring-2 focus:ring-ring"
            style={{ fontSize: 'var(--text-sm)' }}
            data-intercom-target="people-v2-search-input-field"
          />
        </div>
      )}
    </TranslationsContext.Consumer>
  );
}

export default observer(QueryBar);
